import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import locationsData from './locationsData.js';
import reviewsData from './reviews.json';
import SocialLinks from './SocialLinks.js';
import './Splash.scss';

const Splash = () => {
  const location = locationsData[0];
  const [hoursExpanded, setHoursExpanded] = useState(false);
  
  // Get today's hours
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const today = new Date();
  const dayName = days[today.getDay()];
  const todayHours = location.hours.find(h => h.day === dayName);
  const isClosedToday = !todayHours || /closed/i.test(todayHours.hours);

  // Get a featured review (first one with 5 stars)
  const featuredReview = reviewsData.find(r => r.numberOfStars === 5) || reviewsData[0];
  
  // Truncate review text for compact display
  const truncateText = (text, maxLength = 120) => {
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength).trim() + '...';
  };

  // Render stars
  const renderStars = (count) => {
    return Array(count).fill(null).map((_, i) => (
      <span key={i} className="star">★</span>
    ));
  };

  return (
    <section className="splash">
      <div className="splash__background">
        {/* Placeholder background - replace with actual image */}
      </div>
      
      <div className="splash__overlay">
        <div className="splash__content">
          
          {/* Hero Title */}
          <div className="splash__hero">
            <h1 className="splash__title">Domenico's</h1>
            <p className="splash__tagline">Pasadena's Oldest Italian Restaurant</p>
            <p className="splash__established">Est. 1960</p>
            <SocialLinks />
          </div>

          {/* Service hours notice */}
          {!isClosedToday && (
            <div className="splash__service-notice" role="note">
              <span className="splash__service-notice-icon" aria-hidden="true">🍽️</span>
              <p className="splash__service-notice-text">
                <strong>Dine-In served until 4 PM.</strong>{' '}
                After 4 PM — <strong>Take-Out &amp; Delivery only.</strong>
              </p>
            </div>
          )}

          {/* Widgets Container */}
          <div className="splash__widgets">
            
            {/* Order CTA Widget */}
            <div className="splash__widget splash__widget--cta">
              <Link to="/pasadena/order" className="splash__order-btn">
                <span className="splash__order-text">Order Online</span>
                <span className="splash__order-sub">Pickup & Delivery</span>
              </Link>
            </div>

            {/* Hours & Address Widget */}
            <div className="splash__widget splash__widget--info">
              <div className="splash__info-section">
                <h3 className="splash__widget-title">Today's Hours</h3>
                <p className="splash__day">{dayName}</p>
                <p className="splash__hours">{todayHours?.hours || 'Closed'}</p>
                
                {hoursExpanded && (
                  <div className="splash__all-hours">
                    {location.hours.map((h, i) => (
                      <div 
                        key={i} 
                        className={`splash__hours-row ${h.day === dayName ? 'splash__hours-row--today' : ''}`}
                      >
                        <span className="splash__hours-day">{h.day}</span>
                        <span className="splash__hours-time">{h.hours}</span>
                      </div>
                    ))}
                  </div>
                )}
                
                <button 
                  className="splash__more-hours"
                  onClick={() => setHoursExpanded(!hoursExpanded)}
                  aria-expanded={hoursExpanded}
                >
                  {hoursExpanded ? 'Hide hours' : 'More hours'}
                  <span className={`splash__more-hours-icon ${hoursExpanded ? 'splash__more-hours-icon--open' : ''}`}>
                    ▼
                  </span>
                </button>
              </div>
              <div className="splash__divider"></div>
              <div className="splash__info-section">
                <h3 className="splash__widget-title">Visit Us</h3>
                <address className="splash__address">
                  {location.address.map((line, i) => (
                    <span key={i}>{line}</span>
                  ))}
                </address>
                <a href={`tel:${location.phoneLink}`} className="splash__phone">
                  {location.phone}
                </a>
              </div>
            </div>

            {/* Review Widget */}
            <div className="splash__widget splash__widget--review">
              <div className="splash__review-header">
                <div className="splash__stars">
                  {renderStars(featuredReview.numberOfStars)}
                </div>
                <span className="splash__review-source">Google Review</span>
              </div>
              <blockquote className="splash__review-text">
                "{truncateText(featuredReview.reviewText)}"
              </blockquote>
              <cite className="splash__review-author">— {featuredReview.name}</cite>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default Splash;
